
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/phoenix-shade",
      function () {
        return require("private-next-pages/stories/phoenix-shade.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/phoenix-shade"])
      });
    }
  